import { SET_MESSAGE_CLOSE, SET_MESSAGE_OPEN } from './types'

export const setMessageOpen = payload => dispatch => {
  dispatch({ type: SET_MESSAGE_OPEN, payload })
}

export const setMessageClose = () => dispatch => {
  dispatch({ type: SET_MESSAGE_CLOSE })
}
